import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import ContentProvider from "./statics/contentContext/provider";
import { WindowDimensionProvider } from "./statics/dimensionContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <ContentProvider>
    <BrowserRouter>
      <WindowDimensionProvider>
        <App />
      </WindowDimensionProvider>
    </BrowserRouter>
  </ContentProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
